import { Layers, Users, Building2, Wrench, HardHat, Hammer, Truck, MapPin, Briefcase, Home, Store, Factory, Utensils, ShieldCheck, Landmark, GraduationCap, Heart, Package, Zap, Leaf, Star, Flag, Folder, Boxes, Anchor, Plane, Car, Wine } from "lucide-react";

export const GROUP_ICONS = {
  Layers, Users, Building2, Wrench, HardHat, Hammer, Truck, MapPin, Briefcase, Home, Store, Factory, Utensils, ShieldCheck, Landmark, GraduationCap, Heart, Package, Zap, Leaf, Star, Flag, Folder, Boxes, Anchor, Plane, Car, Wine,
};

export const DEFAULT_GROUP_ICON = "Layers";

export function GroupIcon({ name, ...props }) {
  const Icon = GROUP_ICONS[name] || GROUP_ICONS[DEFAULT_GROUP_ICON];
  return <Icon {...props} />;
}

export const GROUP_ICON_NAMES = Object.keys(GROUP_ICONS);
